module.exports = __webpack_public_path__ + "962a1bf31c081691065fe333d9fa8105.svg";